module.exports = __webpack_public_path__ + "img/jjfa_bg.66d93e69.png";